// src/utils/mergeNonEmpty.js
export const mergeNonEmpty = (prev, incoming) => {
  if (!incoming) return prev;
  const next = { ...prev };
  Object.entries(incoming).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (typeof value === "string" && value.trim() === "") return;
    next[key] = value;
  });
  return next;
};